import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Response } from '../models/Response';
import { StudentComment, StudentCommentFormData } from '../models/StudentComment';

@Injectable({
  providedIn: 'root'
})
export class StudentCommentService {
  private baseUrl = `${environment.API_URL}/student-comments`;

  constructor(private http: HttpClient) { }

  /**
   * Get all comments for a student
   */
  getStudentComments(studentId: number, productId?: number | null): Observable<Response<StudentComment[]>> {
    const params: any = {};
    if (productId) params.product_id = productId;
    return this.http.get<Response<StudentComment[]>>(`${this.baseUrl}/student/${studentId}`, { params });
  }

  /**
   * Create a new comment
   */
  createComment(data: StudentCommentFormData): Observable<Response<StudentComment>> {
    return this.http.post<Response<StudentComment>>(this.baseUrl, data);
  }

  /**
   * Update a comment
   */
  updateComment(commentId: number, data: Partial<StudentCommentFormData>): Observable<Response<StudentComment>> {
    return this.http.put<Response<StudentComment>>(`${this.baseUrl}/${commentId}`, data);
  }

  /**
   * Delete a comment
   */
  deleteComment(commentId: number): Observable<Response<void>> {
    return this.http.delete<Response<void>>(`${this.baseUrl}/${commentId}`);
  }

  /**
   * Get comments by context (lesson, practice, exam)
   */
  getCommentsByContext(contextType: string, contextId: number): Observable<Response<StudentComment[]>> {
    return this.http.get<Response<StudentComment[]>>(
      `${this.baseUrl}/context/get?context_type=${contextType}&context_id=${contextId}`
    );
  }
}
